import http from "./httpService";

class ProfessionalDevelopmentService {
  async getAll(params) {
    const url = http.getUrlWithParams("/professional-development", params);
    return http.get(url);
  }

  async adminGetAll(params) {
    const url = http.getUrlWithParams(
      "/admin/professional-development",
      params
    );
    return http.get(url);
  }

  async adminGetById(id) {
    const url = `/admin/professional-development/${id}`;
    return http.get(url);
  }

  async adminCreate(data) {
    const url = "/admin/professional-development";
    const config =
      data instanceof FormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};
    return http.post(url, data, config);
  }

  async adminUpdate(id, data) {
    const url = `/admin/professional-development/${id}`;
    const config =
      data instanceof FormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};
    return http.put(url, data, config);
  }

  async adminDelete(id) {
    const url = `/admin/professional-development/${id}`;
    return http.delete(url);
  }

  async duplicateLesson(id) {
    const url = `/admin/professional-development/duplicate/${id}`;
    return http.post(url);
  }

  async likeLesson(id) {
    const url = `/professional-development/${id}/like`;
    return http.post(url);
  }

  async getBySlug(slug) {
    const url = `/professional-development/slug/${slug}`;
    return http.get(url);
  }

  async requestThumbnailSlides(data) {
    return http.post("/admin/professional-development-slides/upload", data);
  }

  async assignSlides(data) {
    return http.put("/admin/professional-development-slides/assign", data);
  }

  async createBulkMaterials(data) {
    return http.post(
      "/admin/professional-development-instructionals/bulk",
      data
    );
  }

  async createMaterial(data) {
    return http.post("/admin/professional-development-instructionals", data);
  }

  async updateMaterials(id, data) {
    return http.put(
      `/admin/professional-development-instructionals/${id}`,
      data
    );
  }

  async deleteMaterials(id) {
    return http.delete(`/admin/professional-development-instructionals/${id}`);
  }

  async getContentComments(id) {
    return http.get(
      `/professional_development_custom_comments?instructional_strategies_id=${id}&limit=1000&sort_by=created_at&order=asc`
    );
  }

  async createContentComment(data) {
    return http.post("/professional_development_custom_comments", data);
  }

  async updateContentComment(id, data) {
    return http.put(`/professional_development_custom_comments/${id}`, data);
  }

  async deleteContentComment(id) {
    return http.delete(`/professional_development_custom_comments/${id}`);
  }

  async likeContentComment(id) {
    return http.post(`/professional_development_custom_comments/${id}/like`);
  }

  async getProfessionalDevelopmentComments(id) {
    return http.get(
      `/professional_development_comments?instructional_strategies_id=${id}&limit=1000&sort_by=created_at&order=asc`
    );
  }

  async createProfessionalDevelopmentComment(data) {
    return http.post("/professional_development_comments", data);
  }

  async updateProfessionalDevelopmentComment(id, data) {
    return http.put(`/professional_development_comments/${id}`, data);
  }

  async deleteProfessionalDevelopmentComment(id) {
    return http.delete(`/professional_development_comments/${id}`);
  }

  async likeProfessionalDevelopmentComment(id) {
    return http.post(`/professional_development_comments/${id}/like`);
  }

  async viewScorm(id) {
    return http.get(`/professional-development/view/${id}`);
  }
}

export default new ProfessionalDevelopmentService();
